import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

// Clear old Firebase data from localStorage and IndexedDB
// This ensures we use the new co-solution-dev project
if (typeof window !== 'undefined') {
  try {
    // Clear Firebase Auth persistence
    const firebaseKeys = Object.keys(localStorage).filter(key => key.includes('firebase'));
    firebaseKeys.forEach(key => localStorage.removeItem(key));
    
    // Clear IndexedDB
    const dbNames = ['firebase', 'firebaseLocalCache', 'firebaseRemoteCache'];
    dbNames.forEach(dbName => {
      const req = indexedDB.deleteDatabase(dbName);
      req.onerror = () => console.log(`Failed to delete ${dbName}`);
    });
  } catch (e) {
    console.error('Error clearing Firebase data:', e);
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));


// main.ts
// main.ts
/*
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';

import { importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';

import { AngularFireModule } from '@angular/fire/compat'; // ✅
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions'; // ✅

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AngularFireModule.initializeApp(environment.firebase), // ✅
      AngularFireFunctionsModule, // ✅
    ),
  ],
});*/




